import FLD from "../../model/ISIN";
import FIELD_TYPE from "../FieldType";

export default {
    [FLD.id]: {
        "EQ": FIELD_TYPE.M,
        "CV": FIELD_TYPE.M,
        "DT": FIELD_TYPE.M,
        "EN": FIELD_TYPE.M,
        "OP": FIELD_TYPE.M,
        "FT": FIELD_TYPE.M,
        "SP": FIELD_TYPE.M,
        "RI": FIELD_TYPE.M,
        "OT": FIELD_TYPE.M,
        "SO": FIELD_TYPE.M,
        "CO": FIELD_TYPE.M,
        "FW": FIELD_TYPE.M
    },
    [FLD.isinStatus]: {
        "EQ": FIELD_TYPE.M,
        "CV": FIELD_TYPE.M,
        "DT": FIELD_TYPE.M,
        "EN": FIELD_TYPE.M,
        "OP": FIELD_TYPE.M,
        "FT": FIELD_TYPE.M,
        "SP": FIELD_TYPE.M,
        "RI": FIELD_TYPE.M,
        "OT": FIELD_TYPE.M,
        "SO": FIELD_TYPE.M,
        "CO": FIELD_TYPE.M,
        "FW": FIELD_TYPE.M
    },
    [FLD.instrumentCategory]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.issueDescription]: {
        "EQ": FIELD_TYPE.M,
        "CV": FIELD_TYPE.M,
        "DT": FIELD_TYPE.M,
        "EN": FIELD_TYPE.M,
        "OP": FIELD_TYPE.M,
        "FT": FIELD_TYPE.M,
        "SP": FIELD_TYPE.M,
        "RI": FIELD_TYPE.M,
        "OT": FIELD_TYPE.M,
        "SO": FIELD_TYPE.M,
        "CO": FIELD_TYPE.M,
        "FW": FIELD_TYPE.M
    },
    // CFI and FISN is Mandatory for all Instrumentcategories, so set required on the field in IsinFields.tsx. This rule is only to show the asterix in the UI.
    [FLD.cfiCode]: {
        "EQ": FIELD_TYPE.M,
        "CV": FIELD_TYPE.M,
        "DT": FIELD_TYPE.M,
        "EN": FIELD_TYPE.M,
        "OP": FIELD_TYPE.M,
        "FT": FIELD_TYPE.M,
        "SP": FIELD_TYPE.M,
        "RI": FIELD_TYPE.M,
        "OT": FIELD_TYPE.M,
        "SO": FIELD_TYPE.M,
        "CO": FIELD_TYPE.M,
        "FW": FIELD_TYPE.M
    },
    [FLD.fisn]: {
        "EQ": FIELD_TYPE.M,
        "CV": FIELD_TYPE.M,
        "DT": FIELD_TYPE.M,
        "EN": FIELD_TYPE.M,
        "OP": FIELD_TYPE.M,
        "FT": FIELD_TYPE.M,
        "SP": FIELD_TYPE.M,
        "RI": FIELD_TYPE.M,
        "OT": FIELD_TYPE.M,
        "SO": FIELD_TYPE.M,
        "CO": FIELD_TYPE.M,
        "FW": FIELD_TYPE.M
    },
    [FLD.preliminaryTerms]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.nominalValue]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.N,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.N,
        "FT": FIELD_TYPE.N,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.N,
        "FW": FIELD_TYPE.N
    },
    [FLD.issueCurrency]: {
        "EQ": FIELD_TYPE.M,
        "CV": FIELD_TYPE.M,
        "DT": FIELD_TYPE.M,
        "EN": FIELD_TYPE.M,
        "OP": FIELD_TYPE.M,
        "FT": FIELD_TYPE.M,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.smallestDenomination]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.N,
        "FW": FIELD_TYPE.N
    },
    [FLD.conversionRatio]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.N,
        "FW": FIELD_TYPE.N
    },
    [FLD.maturityDate]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.M,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.M,
        "FT": FIELD_TYPE.M,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.M,
        "FW": FIELD_TYPE.M
    },
    [FLD.maturityDateCode]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.M,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.M,
        "FT": FIELD_TYPE.M,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.M,
        "FW": FIELD_TYPE.M
    },
    [FLD.exercisePrice]: {
        "EQ": FIELD_TYPE.N,
        "CV": FIELD_TYPE.N,
        "DT": FIELD_TYPE.N,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.N,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.exercisePriceCurrency]: {
        "EQ": FIELD_TYPE.N,
        "CV": FIELD_TYPE.N,
        "DT": FIELD_TYPE.N,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.N,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.underlyings]: {  // todo a list?
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.interestType]: {
        "EQ": FIELD_TYPE.N,
        "CV": FIELD_TYPE.N,
        "DT": FIELD_TYPE.M,
        "EN": FIELD_TYPE.N,
        "OP": FIELD_TYPE.N,
        "FT": FIELD_TYPE.N,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.N,
        "FW": FIELD_TYPE.N
    },
    [FLD.interestRate]: {
        "EQ": FIELD_TYPE.N,
        "CV": FIELD_TYPE.N,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.N,
        "OP": FIELD_TYPE.N,
        "FT": FIELD_TYPE.N,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.N,
        "FW": FIELD_TYPE.N
    },
    [FLD.interestPayMonth]: {
        "EQ": FIELD_TYPE.N,
        "CV": FIELD_TYPE.N,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.N,
        "OP": FIELD_TYPE.N,
        "FT": FIELD_TYPE.N,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.N,
        "FW": FIELD_TYPE.N
    },
    [FLD.interestPayDay]: {
        "EQ": FIELD_TYPE.N,
        "CV": FIELD_TYPE.N,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.N,
        "OP": FIELD_TYPE.N,
        "FT": FIELD_TYPE.N,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.N,
        "FW": FIELD_TYPE.N
    },
    [FLD.interestFrequency]: {
        "EQ": FIELD_TYPE.N,
        "CV": FIELD_TYPE.N,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.N,
        "OP": FIELD_TYPE.N,
        "FT": FIELD_TYPE.N,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.N,
        "FW": FIELD_TYPE.N
    },
    [FLD.interestFirstPayDate]: {
        "EQ": FIELD_TYPE.N,
        "CV": FIELD_TYPE.N,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.N,
        "OP": FIELD_TYPE.N,
        "FT": FIELD_TYPE.N,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.N,
        "FW": FIELD_TYPE.N
    },
    [FLD.additionalInformationText]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.marketIdCodes]: { // todo lists?
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.leadManagerName]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.N,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.N,
        "FT": FIELD_TYPE.N,
        "SP": FIELD_TYPE.N,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.N,
        "FW": FIELD_TYPE.N
    },
    [FLD.leadManagerLEI]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.N,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.N,
        "FT": FIELD_TYPE.N,
        "SP": FIELD_TYPE.N,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.N,
        "FW": FIELD_TYPE.N
    },
    [FLD.fundManagerName]: {
        "EQ": FIELD_TYPE.N,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.N,
        "EN": FIELD_TYPE.N,
        "OP": FIELD_TYPE.N,
        "FT": FIELD_TYPE.N,
        "SP": FIELD_TYPE.N,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.N,
        "FW": FIELD_TYPE.N
    },
    [FLD.fundManagerLEI]: {
        "EQ": FIELD_TYPE.N,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.N,
        "EN": FIELD_TYPE.N,
        "OP": FIELD_TYPE.N,
        "FT": FIELD_TYPE.N,
        "SP": FIELD_TYPE.N,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.N,
        "FW": FIELD_TYPE.N
    },
    [FLD.csdName]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.centralSecDepsAndLEIs]: {    // todo a list of objects!!
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.issuerNameLong]: {
        "EQ": FIELD_TYPE.M,
        "CV": FIELD_TYPE.M,
        "DT": FIELD_TYPE.M,
        "EN": FIELD_TYPE.M,
        "OP": FIELD_TYPE.M,
        "FT": FIELD_TYPE.M,
        "SP": FIELD_TYPE.M,
        "RI": FIELD_TYPE.M,
        "OT": FIELD_TYPE.M,
        "SO": FIELD_TYPE.M,
        "CO": FIELD_TYPE.M,
        "FW": FIELD_TYPE.M
    },
    [FLD.issuerLEI]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.issuerNameShort]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.issuerSupranational]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.N,
        "FW": FIELD_TYPE.N
    },
    [FLD.issuerHQAddress1]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.issuerHQAddress2]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.issuerHQStateProvince]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.issuerHQPostCode]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.issuerHQCity]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.issuerHQCountry]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.issuerLegalRegAddress1]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.issuerLegalRegAddress2]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.issuerLegalRegStateProvince]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.issuerLegalRegPostCode]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.issuerLegalRegCity]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.issuerLegalRegCountry]: {
        "EQ": FIELD_TYPE.M,
        "CV": FIELD_TYPE.M,
        "DT": FIELD_TYPE.M,
        "EN": FIELD_TYPE.M,
        "OP": FIELD_TYPE.M,
        "FT": FIELD_TYPE.M,
        "SP": FIELD_TYPE.M,
        "RI": FIELD_TYPE.M,
        "OT": FIELD_TYPE.M,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.oldIsin]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.newIsin]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.callPut]: {
        "EQ": FIELD_TYPE.N,
        "CV": FIELD_TYPE.N,
        "DT": FIELD_TYPE.N,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.N,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.underlyingInstrumentName]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.N,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.N,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.O,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.headOfficeLEI]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    },
    [FLD.headOfficeName]: {
        "EQ": FIELD_TYPE.O,
        "CV": FIELD_TYPE.O,
        "DT": FIELD_TYPE.O,
        "EN": FIELD_TYPE.O,
        "OP": FIELD_TYPE.O,
        "FT": FIELD_TYPE.O,
        "SP": FIELD_TYPE.O,
        "RI": FIELD_TYPE.O,
        "OT": FIELD_TYPE.O,
        "SO": FIELD_TYPE.N,
        "CO": FIELD_TYPE.O,
        "FW": FIELD_TYPE.O
    }
}